import { LocaleLanguageCode } from 'Constants/Common';
import { parseDate } from 'helpers/dateTime';
import { useTranslation } from 'react-i18next';

const fallbackLocale = LocaleLanguageCode.GB;
function useLocaleFormatter() {
    const { t } = useTranslation();

    const toLocalDate = (
        date: string | Date | number,
        { locale: customLocale = '' } = {}
    ) => {
        const dateObj = parseDate(date);

        if (!dateObj) {
            return t('invalid_date');
        }

        try {
            const locale = customLocale || navigator.language;
            return Intl.DateTimeFormat([locale, fallbackLocale]).format(
                dateObj
            );
        } catch {
            return Intl.DateTimeFormat(fallbackLocale).format(dateObj);
        }
    };

    return { toLocalDate };
}

export { useLocaleFormatter };
